import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import InputBase from "@mui/material/InputBase";
import { Grid,useMediaQuery } from "@mui/material";
import "../../styles/header.scss";

import MobileMenu from "../Nav";

//import { loginDetailsByAdmin } from "../../../login/reducers/loginThunk";

const Search = styled("div")({
  position: "relative",
  marginLeft: 0,
  width: "50%",
});

const SearchIconWrapper = styled("div")({
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const StyledInputBase = styled(InputBase)({
  color: "inherit",
  width: "100%",
});

export default function PrimarySearchAppBar() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentRoute, setCurrentRoute] = React.useState();
  const isMobile = useMediaQuery('(max-width:768px)');

  useEffect(() => {
    const access_token = sessionStorage.getItem("access_token");
    const token = access_token ? access_token : "";

    /*  if (token) {
      window.location = "/Dashboard";
    } else {
      window.location = "/login";
    } */
  }, []);

  useEffect(() => {
    if (location && location.pathname) {
      switch (location.pathname) {
        case "/Dashboard":
          setCurrentRoute("Dashboard");
          break;
        case "/userManagement":
          setCurrentRoute("User Management");
          break;
        case "/orgManagement":
          setCurrentRoute("Organization Management");
          break;
        case "/logManagement":
          setCurrentRoute("Log Management");
          break;
        case "/WorkManagement":
          setCurrentRoute("Work Management");
          break;
        case "/Coupons":
          setCurrentRoute("Coupons");
          break;
        case "/Plans":
          setCurrentRoute("Plans");
          break;
        case "/Reports":
          setCurrentRoute("Reports");
          break;
        default:
          setCurrentRoute("Dashboard");
      }
    }
  }, [location.pathname]);

  return (
    <Box sx={{ flexGrow: 0.1 }}>
      <AppBar elevation={0} position="static" id="header" className="colored">
        <Toolbar>
          <Grid container>
            <Grid item xs={12} sm={12}>
              <Grid container>
                <Grid item xs={12} sm={7}>
                  <Grid container> <Grid item xs={1} sm={2}>
                  {isMobile && <>
                   <MobileMenu /></>}
                     </Grid> 
                    <Grid item xs={11} sm={10}>
                       <Grid container>
                         <Grid item xs={12} sm={8}>
                      <div className="Data_Entry" style={{fontSize:isMobile && "14px",justifyContent:"center",display:"flex"}}>{currentRoute}</div>
                       </Grid>
                        </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Grid container>
                    <Grid item xs={12}>
                      <div className="Data_Entry" style={{fontSize:isMobile && "14px",justifyContent:"center",display:"flex"}}>Super Admin Portal</div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={7}></Grid>
                    <Grid item xs={12} sm={2} id="profilename"></Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
